import { readStates, updateStates } from '@/constants/lifecycle';

export const roleActionsDialogState = () => ({
  open: false,
  code: null,
  category: null,
  roleActions: [],
  ...updateStates,
});

export const roleActionsState = {
  ...readStates,
  ...updateStates,
  items: [],
};
